export enum Breakpoints {
  Small = 768,
  Tablet = 870,
  Medium = 1024,
  Large = 1280,
  Max = 1920,
}
